export default __webpack_public_path__ + "static/media/1027-00 folded.61473f44.jpg";